<template>
    <b-modal 
      centered 
      id="ModalTariffsRecaudos" 
      modal-class="dialog-1600"
      class="mb-4"
      :title="$t('Tarifas de Recaudos')"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      @close="close"
    >
      <div v-if="!loading.collectionOnDelivery" class="modal-tariffs-recaudos">
        <b-tabs align="left" class="tab-primary" v-model="tabIndex" active-nav-item-class="active-modal-tariffs-recaudos" @input="handleTabChange">
          <b-tab v-for="(carrier, index) in carrierTabs" :key="carrier.id" :class="{ active: tabIndex === index }">
            <template #title>
              <img :src="carrier.logotypes[0].url" alt="Logo" width="100" height="50" />
            </template>
          </b-tab>
        </b-tabs>
        <div class="mb-1">
          <li>
            <span class="text-services-collections">Servicios a los que aplica: </span>{{ formattedLimitServices }}
          </li>
        </div>
        <b-table :items="collectionOnDelivery.rows" :fields="fields" class="collection-table-catalog" responsive borderless>
        </b-table>
      </div>
      <div class="table-render-skeleton" v-if="loading.collectionOnDelivery">
        <b-skeleton-table :rows="1" :columns="fields.length || 10" />
      </div>
    </b-modal>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'ModalTariffsRecaudos',
  props: {
    info: {
      type: Array,
      default: () => []
    },
    isComparator: {
      type: Boolean,
      default: false
    },
    closeModal: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      keyModalTariffsRecaudos: 0,
      loading: {
        collectionOnDelivery: true
      },
      fields: [],
      tabIndex: 0
    }
  },
  computed: {
    ...mapGetters({
      collectionOnDelivery: 'getCollectionOnDelivery',
      generalLoading: 'getLoading'
    }),
    logoUrl() {
      return this.info?.logotypes?.[0]?.url || null
    },
    formattedLimitServices() {
      if (
        this.collectionOnDelivery &&
        this.collectionOnDelivery.rows &&
        this.collectionOnDelivery.rows[0] &&
        Array.isArray(this.collectionOnDelivery.rows[0].limit_services)
      ) {
        // Filtrar los servicios donde show_in_catalag es true
        const visibleServices = this.collectionOnDelivery.rows[0].limit_services
          .filter(service => service.show_in_catalog)
          .map(service => service.name) // Obtener solo los nombres

        // Unir los nombres en un string separado por comas
        return visibleServices.length > 0 ? visibleServices.join(', ') : 'No hay servicios disponibles aqui'
      }
      return 'No hay servicios disponibles'
    },
    carrierTabs() {
      return this.buildCarrierArray()
    }
  },
  watch: {
    collectionOnDelivery() {
      this.setCollectionOnDelivery()
    },
    generalLoading: {
      handler () {
        this.loading.collectionOnDelivery = !!this.generalLoading.getCollectionOnDelivery
      },
      deep: true
    },
    cleanFilters() {
      this.cleanFilter()
    }
  },
  mounted () {
    this.setInitialData()
    this.getFirstCarrier()
  },
  methods: {
    setInitialData() {
      this.setFields()
    },
    setFields() {
      this.fields = [
        { key: 'min_val', label: 'Valor mínimo recaudo', class:'text-left'},
        { key: 'max_val', label: 'Valor máximo recaudo', class:'text-left'},
        { key: 'percentage_cash', label: 'Recaudo contra entrega efectivo', class:'text-left'},
        { key: 'cash', label: 'Mínimo pago por recaudo efectivo', class:'text-left' },
        { key: 'percentage_instant_payment', label: 'Recaudo contra entrega débito/prepago/PSE', class:'text-left'},
        { key: 'instant_payment', label: 'Mínimo pago por recaudo débito/prepago/PSE', class:'text-left' },
        { key: 'percentage_credit_card', label: 'Recaudo contra entrega crédito', class:'text-left' },
        { key: 'credit_card', label: 'Mínimo pago por recaudo crédito', class:'text-left' }
      ]
    },
    setCollectionOnDelivery() {
      this.rows = this.collectionOnDelivery.rows
      this.keyModalTariffsRecaudos++
    },
    buildCarrierArray() {
      const courierIds = this.$route.query.courier_ids
      if (courierIds || typeof courierIds === 'string') {
        const courierIdsArray = courierIds.split(',').map(id => parseInt(id.trim(), 10))
        const carrierArray = courierIdsArray.map(id => {
          const carrierData = this.info.find(item => item.data.carrier.id === id)
          if (!carrierData) return null
          return {
            country_id: carrierData.data.carrier.country_id,
            logotypes: carrierData.data.carrier.logotypes,
            id: carrierData.data.carrier.id,
            code: carrierData.data.carrier.code,
            name: carrierData.data.carrier.name,
            master_carrier_id: carrierData.data.carrier.master_carrier_id
          }
        }).filter(item => item !== null) // Filtrar los valores nulos
        return carrierArray
      } else {
        return [{
          country_id: this.info[0]?.carrier.country_id,
          logotypes: this.info[0]?.carrier.logotypes,
          id: this.info[0]?.carrier.id,
          code: this.info[0]?.carrier.code,
          name: this.info[0]?.carrier.name,
          master_carrier_id: this.info[0]?.carrier.master_carrier_id
        }]
      }
    },
    getFirstCarrier() {
      const carrierArray = this.buildCarrierArray()
      if (this.isComparator) {
        this.country = carrierArray[0]?.country_id
        this.carrier = carrierArray[0]?.id
        this.getCollectionOnDelivery(this.tabIndex)
      } else {
        this.country = this.info[0]?.carrier.country_id
        this.carrier = this.info[0]?.carrier.id
        this.getCollectionOnDelivery(this.tabIndex)
      }
    },
    getCollectionOnDelivery() {
      this.showTable = true
      const params = {
        country_id:  this.country
      }
      const queryParams = {}
      if (this.carrier) queryParams.carrier_ids = this.carrier
      this.$store.dispatch('fetchService', { name: 'getCollectionOnDelivery', params, queryParams })
    },
    handleTabChange(index) {
      const selectedCarrier = this.carrierTabs[index]
      if (selectedCarrier) {
        this.country = selectedCarrier.country_id
        this.carrier = selectedCarrier.id
        this.getCollectionOnDelivery()
      }
    },
    close() {
      this.$emit('closeModal')
    }
  }
}
</script>
<style lang="scss">
  .text-services-collections{
    color: #39549f;
    font-weight: 600;
  }
  .collection-table-catalog {
    table {
      border-collapse: separate !important; /* Asegura que el espacio entre celdas sea respetado */
      border-spacing: 0 10px !important; /* Agrega 10px de separación vertical entre el <thead> y el <tbody> */
    }
    thead {
      background: none !important;
      color: #fff;
      font-weight: 600;
      margin-top: 10px;
      border-radius: 10px;
      th {
        background: #39549f !important;
      }
      th:first-child {
        border-radius: 50px 0 0 50px;
      }
      th:last-child {
        border-radius: 0 50px 50px 0;
      }
    }
    tbody {
      tr {
        height: 5rem;
        td {
          background: rgba(244, 253, 252, 1) !important;
          color: rgba(111, 108, 124, 1);
          font-weight: 300;
          padding: 5rem;
        }
        td:first-child {
          border-radius: 50px 0 0 50px;
        }
        td:last-child {
          border-radius: 0 50px 50px 0;
        }
      }
    }
  }
.modal-tariffs-recaudos .nav-tabs .nav-link {
  opacity: 0.5;
  transition: opacity 0.3s ease;
}

.active-modal-tariffs-recaudos {
  opacity: 1 !important;
}
</style>